<template lang="pug">
div
  b-button.floating-btn(@click="isOpen = !isOpen" style="border-radius: 30px; margin-top: 0.3rem; padding: 0.71rem; align-items: center; width: fit-content; display: flex;")
    b-icon(style="padding-top: 0.12rem; color: #181818;" icon="list-ul")
    span.pl-2.code-counter(v-if="itemsCount") {{ itemsCount }}
  b-modal#scanned-deliveries-modal(
    v-model="isOpen"
    hide-footer title="Envíos Escaneados" centered
  )
    .scanned-delivery-container
      h6.text-center.text-muted.mb-2.font-weight-bold.small(v-if="images.length") Imágenes de solicitud
      .images-container.mb-2(v-if="images.length")
        .image-item(v-for="image in images" :key="image.id")
          img(:src="image" alt="")
      b-table(
        :items="deliveries"
        :fields="fields"
        responsive
        striped
        hover
        show-empty
        empty-text="No hay envíos escaneados aún"
      )
        template(#empty="scope")
          .text-center.text-muted No hay envíos escaneados aún.
</template>

<script>
export default {
  name: 'ScannedDeliveriesTable',
  props: {
    deliveries: {
      type: Array,
      required: true,
      default: () => []
    },
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false,
      fields: [
        { key: 'drivInCode', label: 'Código' },
        { key: 'commune', label: 'Comuna' },
        { key: 'address', label: 'Dirección' },
        { key: 'finalCustomer', label: 'Cliente' }
      ]
    }
  },
  computed: {
    itemsCount() {
      return this.deliveries.length + this.images.length
    }
  }
}
</script>

<style scoped>
.floating-btn {
  z-index: 1050;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  background-color: white;
}

.code-counter {
  color: #13475c;
}

.scanned-delivery-container {
  padding: 0.7rem 0.4rem;
  height: 60vh;
  overflow-y: auto;
  padding-bottom: 20px;
}

.images-container {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
}

.image-item {
  width: 100px;
  min-width: 100px;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>

<style>
#scanned-deliveries-modal {

  .modal-dialog-centered {
    align-items: end !important;
  }

  .modal-content {
    border-radius: 16px 16px 0 0 !important;
    transition-timing-function: ease-out !important;
    transition-duration: 300ms !important;

    .modal-body {
      padding: 0.7rem 0.4rem;
      padding-bottom: 0;
    }

    .table th,
    .table td {
      padding: 0.4rem;
      vertical-align: middle;
      font-size: 15px;
      font-weight: 400;
    }
  }
}
</style>